import { PDFDocument } from "@cantoo/pdf-lib";

export type PdfFieldWidget = {
    name: string;
    pageIndex: number;
    x: number;
    y: number;
    width: number;
    height: number;
};

export async function extractPdfFieldWidgets(pdfBytes: ArrayBuffer): Promise<PdfFieldWidget[]> {
    const pdfDoc = await PDFDocument.load(pdfBytes);
    const form = pdfDoc.getForm();
    const fields = form.getFields();
    const pages = pdfDoc.getPages();

    const widgets: PdfFieldWidget[] = [];

    fields.forEach((field: any) => {
        // pdf-lib exposes widgets on the low-level acroField
        const acro: any = field.acroField;
        const fieldWidgets = acro?.getWidgets ? acro.getWidgets() : [];

        for (const widget of fieldWidgets) {
            const rect = widget.getRectangle();
            const x1 = Math.min(rect.x, rect.x + rect.width);
            const y1 = Math.min(rect.y, rect.y + rect.height);
            const x2 = Math.max(rect.x, rect.x + rect.width);
            const y2 = Math.max(rect.y, rect.y + rect.height);

            let pageIndex = pages.findIndex((page: any) => page.ref === widget.P());

            if (pageIndex < 0) {
                const widgetRef = pdfDoc.context.getObjectRef(widget.dict);
                const page = widgetRef ? pdfDoc.findPageForAnnotationRef(widgetRef) : undefined;
                pageIndex = page ? pages.indexOf(page) : -1;
            }

            if (pageIndex < 0) {
                continue;
            }

            widgets.push({
                name: field.getName(),
                pageIndex,
                x: x1,
                y: y1,
                width: x2 - x1,
                height: y2 - y1,
            });
        }
    });

    return widgets;
}
